import {loadStripe} from '@stripe/stripe-js';

const stripePromise = loadStripe("pk_test_51QLFO4GAVPgDriTXdMz3HaGpaErmEEG9g1Woc2ASoEMgUeaNWxQpYE9FpwgSgHc4xnSx6B78mJsLPOCjGvoMitXO00A2gGcqJS");


export {stripePromise}